import NavCard from "./NavCard"

const LargeNavCard = ({...props}) => <NavCard {...props} xs={12} lg={6} md={undefined} />

export default LargeNavCard